const resourcesListInit = () => {
  const mainPatterns = document.querySelectorAll('.gg-resources-list');

  if (mainPatterns.length === 0) return;

  let currentUrl = window.location.href;
  let hasContentTypeFilter = /content_type=/.test(currentUrl);
  let hasContentTypePost = /content_type=blogs/.test(currentUrl);
  let hasContentTypeWebinars = /content_type=webinars/.test(currentUrl);
  let hasTaxonomyFilter = /taxonomy=/.test(currentUrl);
  let hasContentTypeAll = !currentUrl.includes('?');


  mainPatterns.forEach((module) => {

    let label = module.querySelector('label[for="post"]');
    const optionSelectFirst = module.querySelector('.gravity-block-filters__select option:first-child')
    const filterBlogs = module.querySelector('.gravity-block-filters__type:has(select[data-taxonomy="category"])');
    const filterWebinars = module.querySelector('.gravity-block-filters__type:has(select[data-taxonomy="on_demand_webinars-categories"])');
    if (label) {
      label.textContent = 'Blogs';
    }

    if (!hasContentTypeAll && (hasContentTypePost || !hasContentTypeFilter || hasContentTypeWebinars)) {
      module.classList.add('gg-has-categories');
    } else {
      module.classList.remove('gg-has-categories');
    }


    if (hasContentTypePost) {
      if (filterWebinars) filterWebinars.style.display = 'none';
      if (filterBlogs) filterBlogs.style.display = 'block';
    } else if (hasContentTypeWebinars) {
      if (filterBlogs) filterBlogs.style.display = 'none';
      if (filterWebinars) filterWebinars.style.display = 'block';
    } else {
      if (filterBlogs) filterBlogs.style.display = 'none';
      if (filterWebinars) filterWebinars.style.display = 'none';
    }

    if (hasTaxonomyFilter) {
      module.classList.add('gg-has-taxonomy-filter');
    } else {
      module.classList.remove('gg-has-taxonomy-filter');
    }
  });
};


const monitorUrlChanges = () => {
  resourcesListInit();

  window.addEventListener('popstate', () => {
    resourcesListInit();
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    resourcesListInit();
  };
  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    resourcesListInit();
  };
};
monitorUrlChanges();
